import React, {useEffect, useState} from 'react';
import {TextField} from "@mui/material";

/**
 * Универсальный компонент выбора времени с точностью до минут.
 * Использует нативный input type="time" (MUI TextField), по умолчанию 00:00.
 *
 * @param date         текущая дата события (берётся для начального значения)
 * @param changeTime   колбэк, получает объект {hours, minutes}
 * @param style        стили обёртки
 * @param label        подпись поля
 * @param defaultTime  опциональное время по умолчанию в виде {name: seconds}
 */
export default function TimeInput({date, changeTime, style, label = "Time", defaultTime}) {

    const [value, setValue] = useState("00:00");

    function getHoursAndMinutes(seconds) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        return {hours, minutes};
    }

    function toTimeString(hours, minutes) {
        const hh = String(hours).padStart(2, '0');
        const mm = String(minutes).padStart(2, '0');
        return `${hh}:${mm}`;
    }

    useEffect(() => {
        if (defaultTime !== undefined && defaultTime !== null) {
            const keys = Object.keys(defaultTime);
            const seconds = defaultTime[keys[0]];
            const time = getHoursAndMinutes(seconds);
            setValue(toTimeString(time.hours, time.minutes));
            changeTime(time);
        } else {
            const hours = date.getHours();
            const minutes = date.getMinutes();
            setValue(toTimeString(hours, minutes));
        }
    }, []);

    function handleChange(event) {
        const newValue = event.target.value; // формат "HH:mm"
        setValue(newValue);

        if (!newValue) {
            return;
        }

        const [hours, minutes] = newValue.split(':').map((part) => Number.parseInt(part, 10));
        changeTime({hours, minutes});
    }

    return (
        <TextField
            type="time"
            label={label}
            variant="standard"
            value={value}
            onChange={handleChange}
            style={style}
            InputLabelProps={{shrink: true}}
            inputProps={{step: 60}}
        />
    );
}
